import { Capacitor } from '@capacitor/core';

// Native builds bundle the web code (capacitor://localhost, https://localhost), so a relative
// "/api/..." would not reach Vercel. They call the production host; the web app uses its own origin.
export const API_BASE = Capacitor.isNativePlatform() ? 'https://miiq-fitfinder.vercel.app' : '';

export async function postApi(path, body) {
  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  let data = null;
  try { data = await response.json(); } catch { data = null; }
  if (!response.ok) {
    const error = new Error(data?.error || `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return data;
}
